import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_V2_URL}/problems`;

export const getProblems = createAsyncThunk(
    "problems/getProblems",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(API_BASE_URL, { params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error fetching data");
        }
    }
);

export const getProblemById = createAsyncThunk(
    "problems/getProblemById",
    async ({ id, params }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/${id}/`, {
                params
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error fetching details");
        }
    }
);

export const postMessage = createAsyncThunk(
    "problems/postMessage",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/${id}/new-message/`, payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error posting a message");
        }
    }
);

const problemAPISlice = createSlice({
    name: "problems",
    initialState: {
        list: [],
        selectedById: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getProblems.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProblems.fulfilled, (state, action) => {
                state.loading = false;
                
                // Check if it's a cursor-based pagination request (for infinite scroll)
                if (action.meta.arg.cursor) {
                    // Append results to existing list (infinite scroll)
                    state.list = [...state.list, ...action.payload.results];
                } else {
                    // Replace the entire list (initial load or filter change)
                    state.list = action.payload.results;
                }
            })
            .addCase(getProblems.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getProblemById.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProblemById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedById = action.payload;
            })
            .addCase(getProblemById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(postMessage.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postMessage.fulfilled, (state, action) => {
                state.loading = false;
                const messager_user_type = action.payload.user_type
                if (state.selectedById.messages) {
                    state.selectedById.messages.push(action.payload);
                }

                state.selectedById.status = messager_user_type === 'JS' ? 'WAITING_FOR_ISSARA' : 'WAITING_FOR_WORKER'
            })
            .addCase(postMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default problemAPISlice.reducer;